import React from 'react';
import styles from '../styles';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { nameOrEmail } from '../../../../utils/helper';
import Grid from '../../../Common/Grid/index';

const COLUMNS = [
  { name: 'reference', title: 'Reference' },
  { name: 'customer', title: 'Customer' },
  { name: 'description', title: 'Description' },
  { name: 'start', title: 'Start' },
  { name: 'end', title: 'End' },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'reference', width: 150 },
  // { columnName: 'action', width: 100 },
  // { columnName: 'action', width: 100 },
  // { columnName: 'action', width: 100 },
  { columnName: 'tasks', width: 100 },
  { columnName: 'action', width: 100 },
];

const getCellComponent = (onSelect) => ({ row, column, value }) => {
  switch (column.name) {
    case 'customer':
      return nameOrEmail(value);
    case 'start':
    case 'end':
      return value ? moment(value).format('ll') : '';
    case 'action':
      return (<Tooltip placement="bottom" title="Select"><IconButton onClick={() => onSelect(row)}>
        <ChevronRightIcon style={styles.select}/>
      </IconButton></Tooltip>);
    default :
      return value;
  }
};

class JobsGrid extends React.Component {

  render() {
    const { data, fetch, onSelect } = this.props;

    return (<Grid
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      cellComponent={getCellComponent(onSelect)}
      data={data}
      fetch={fetch}
    />);
  }
}

export default JobsGrid;



// WEBPACK FOOTER //
// ./src/components/Jobs/FindJobDialog/JobsGrid/index.js